import { render } from "./Payments.vue?vue&type=template&id=4f49b6cc&scoped=true"
import script from "./Payments.vue?vue&type=script&lang=js"
export * from "./Payments.vue?vue&type=script&lang=js"

import "./Payments.vue?vue&type=style&index=0&id=4f49b6cc&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/ZEPPELIN/mi-stock-zeppelin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f49b6cc"]])

export default __exports__